/** Parses HTTP cookie and extracts Lab CSRF token */
const extractCsrfToken = (cookie: string): null | string => {
  if (!cookie) return null;
  const cookieEntries = cookie.split(';');
  const csrfToken = cookieEntries.find((i) => i.includes('csrftoken='));
  const csrfTokenMap = csrfToken?.split('=') || [null, null];
  const [csrfTokenKey, csrfTokenValue] = csrfTokenMap;
  if (!csrfTokenKey || !csrfTokenValue) return null;
  return csrfTokenValue;
};

const CSRFElementRE = /<input type="hidden" name="csrfmiddlewaretoken" value="([a-zA-Z0-9]+)">/;

const extractCsrfTokenFromResponse = (response: string): null | string => {
  if (!response) return null;
  console.log('CSRFElementRE', CSRFElementRE);
  const matches = CSRFElementRE.exec(response);
  if (!matches) return null;

  return matches[1];
};

const loginMapper = { extractCsrfToken, extractCsrfTokenFromResponse };

export default loginMapper;
